import { gql } from '@apollo/client';

export const SocialAuth = gql`
    mutation socialAuth($provider: String!, $accessToken: String!) {
        socialAuth(provider: $provider, accessToken: $accessToken) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
